import { render } from "./EquipmentInspectionComponent.vue?vue&type=template&id=1882c5a4"
import script from "./EquipmentInspectionComponent.vue?vue&type=script&lang=js"
export * from "./EquipmentInspectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__